import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Maybe } from "@ispb/react-hooks";
import { Fragment } from "react";
import { Card, Modal } from "react-bootstrap";
import Blocker from "../components/Blocker.js";
import IconButton from "../components/IconButton.js";
import IconText from "../components/IconText.js";
import Spacer from "../components/Spacer.js";
import { STANDARD_SPACING } from "../config.js";
import { CLOSE_ICON, LOADING_ICON } from "../icons.js";
import LoadingBar from "./LoadingBar.js";
import LoadingIcon from "./LoadingIcon.js";
import LoadingPage from "./LoadingPage.js";
import LoadingTable from "./LoadingTable.js";
import ReloadingBox from "./ReloadingBox.js";
import ReloadingPage from "./ReloadingPage.js";
/**
 * A reloading component that shows nothing and doesn't wrap the children.
 */
export const INVISIBLE_RELOADING = (props) => _jsx(Fragment, { children: props.children });
/**
 * The global lazy overrides.
 */
export const PAGE_LAZY = {
    onLoading: (props) => _jsx(LoadingPage, { title: props.message }),
    onReloading: (props) => _jsx(ReloadingPage, { ...props }),
    // delay: LAZY_DELAY,
};
/**
 * The lazy overriddes for the user interface once logged in.
 */
export const INTERNAL_FULL_PAGE_LAZY = {
    onLoading: () => _jsx(LoadingBar, {}),
    onReloading: (props) => _jsx(ReloadingPage, { ...props }),
    //  delay: LAZY_DELAY,
};
/**
 * The lazy overriddes for the user interface once logged in.
 */
export const INTERNAL_LAZY = {
    onLoading: () => _jsx("div", { children: _jsx(LoadingBar, {}) }),
    onReloading: (props) => _jsx(ReloadingBox, { ...props }),
    //  delay: LAZY_DELAY,
};
export const INTERNAL_BODY_LAZY = {
    onLoading: () => _jsx(LoadingBar, {}),
    onReloading: (props) => _jsx(ReloadingBox, { ...props }),
    //  delay: LAZY_DELAY,
};
/**
 * Lazy overrides for modal popups.
 * @param onHide What to do if the loading modal is hidden.
 * @returns A set of lazy overrides.
 */
export function modalLazy(modalProps) {
    return {
        onReloading: props => _jsx(Modal, { ...modalProps, children: _jsx(Blocker, { className: "d-flex flex-grow-1 flex-column", blocking: props.reloading, children: props.children }) }),
        onLoading: () => {
            return (_jsx(Modal, { show: true, onHide: modalProps.onHide, centered: true, contentClassName: "bg-transparent border-0", children: _jsx(Modal.Body, { className: "text-center opacity-75", children: _jsx("div", { className: "p-" + STANDARD_SPACING, children: _jsxs("div", { className: "pb-0 p-" + STANDARD_SPACING, children: [_jsx(LoadingIcon, { style: { width: "100%", height: "auto" }, className: "w-100" }), _jsx(Maybe, { value: modalProps.onHide, children: onHide => {
                                        return (_jsxs(Fragment, { children: [_jsx(Spacer, {}), _jsx(Spacer, {}), _jsx(Spacer, {}), _jsx(IconButton, { onClick: onHide, icon: CLOSE_ICON, variant: "dark", size: "lg", children: "Cancel" })] }));
                                    } })] }) }) }) }));
        },
        //delay: LAZY_DELAY,
    };
}
/**
 * Lazy overrides for a table. Shows headers and a loading row.
 * @param columns Names of the columns.
 * @returns A set of lazy overrides.
 */
export function tableLazy(columns) {
    return {
        onLoading: (props) => _jsx(LoadingTable, { columns: columns, title: props.message }),
        onReloading: (props) => _jsx(ReloadingPage, { ...props }),
    };
}
export function cardLazy() {
    return {
        onLoading: (props) => {
            return (_jsx(Fragment, { children: _jsx(Card.Title, { className: "mb-0", children: _jsx(IconText, { ...LOADING_ICON, children: props.message ?? "Loading..." }) }) }));
        },
        onReloading: (props) => _jsx(ReloadingBox, { ...props }),
    };
}
/**
 * A lazy loading bootstrap button.
 */
export function buttonLazy(title, props) {
    return {
        onLoading: () => _jsx(IconButton, { icon: LOADING_ICON, children: title, disabled: true, variant: "light", ...props }),
        onReloading: (props) => _jsx(ReloadingBox, { ...props }),
    };
}
/**
 * Creates lazy overrides for a nav item.
 */
/*
TODO rm
export function navLazy(title: string, collapse: Break = "xl") {
    return {
        onLoading: () => <NavLoading collapse={collapse} title={title} />,
        onReloading: (props: ReloadingProps) => <ReloadingBox {...props} />,
    }
}
*/
export function nodeLazy(text) {
    return {
        onLoading: props => props.message ?? text,
        onReloading: props => props.reloading ? props.message ?? text : props.children,
    };
}
